import { ICellRendererParams } from "ag-grid-enterprise";
import React from "react";

import { styled } from "@mui/material/styles";
import { GenericFlexStartContainer } from "@src/components/MainApp/SharedProductPicker/list/containers";
import { useProductImage } from "@src/hooks/products";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

const Image = styled("img")({
  width: 40,
  height: 40,
  objectFit: "cover",
  borderRadius: 5,
});

export const ProductListImage = ({
  data,
}: ICellRendererParams<ProductPickerSelectedProduct>) => {
  const image = useProductImage(data?.id, data?.image);
  return (
    <GenericFlexStartContainer>
      <Image alt={data?.title} src={image} />
    </GenericFlexStartContainer>
  );
};
